import { PureComponent } from 'react';
import { Info2 } from '@dbk/ui-icons';
import { View } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import Modal from '@dbk/ui-modal';
import { PALETTE } from '../../../constants';
import Helptext from './Helptext';
import isEnterorSpaceKeyPressed from '../../../utils/isEnterorSpaceKeyPressed';
import status from './vopValStatus';
import { VOP_VALIDATE_CODES } from '../constant';
import { FormattedMessage } from '@dbk/format';

class HelptextDescription extends PureComponent {
  constructor(props) {
    super(props);
    this.state={
      showDescModal: false,
    }
  }

  componentDidUpdate() {
    if(document.querySelector('.modal__header-container')){ 
      document.querySelector('.modal__header-container').focus();
    }
  }

  handleDescModal = (flag, e) => {
    if(isEnterorSpaceKeyPressed(e)){
      this.setState({
        showDescModal: flag,
      });
    }
  }

  renderDescModalHeader = () => {
    const { i18n: { messages } } = this.props;
    return (
      <>
        <View>
          <Text>{messages["app.payments.vop.descModal.msg1"]}</Text>
        </View>
        <View className="pad-bottom-20">
          <Text>{messages["app.payments.vop.descModal.msg2"]}</Text>
        </View>
      </>
    )
  }

  renderDescModalStatus = () => {
    const { i18n: { messages } } = this.props;
    return (
      <>
        <View className="pad-bottom-10">
          <Text>{messages["app.payments.vop.helptext.desc.header"]}</Text>
        </View>
        <View className="helptext-desc-box">
          {status.map((statusItem, index) => (
            <>
              <View
                className={index === 0 ? 'pad-bottom-10' : 'pad-ver-10'}
                key={statusItem.code}
              >
                <Helptext verCode={statusItem.code} messages={messages} />
              </View>
              {statusItem.descs.map((desc, idx) => (
                <View
                  className={
                    idx === statusItem.descs.length - 1 &&
                    index !== status.length - 1
                      ? 'pad-bottom-20'
                      : ''
                  }
                  key={idx}
                >
                  {
                    statusItem.code === VOP_VALIDATE_CODES.CLOSED_MATCH && idx === 0
                      ? <FormattedMessage
                        id={desc}
                        values={{ Exact_Name: <Text secondary className='helptext__text--sub-text'>{messages["app.payments.vop.helptext.closedMatch.exactName"]}</Text> }}
                      >
                        {(text) => <Text>{text}</Text>}
                      </FormattedMessage>
                      : <Text>{messages[desc]}</Text>
                  }
                </View>
              ))}
            </>
          ))}
        </View>
      </>
    )
  }

  renderDescModalFooter = () => {
    const { i18n: { messages } } = this.props;
    return (
      <>
        <View className="pad-top-10">
          <Text>{messages["app.payments.vop.descModal.msg3"]}</Text>
        </View>
        <View>
          <Text>{messages["app.payments.vop.descModal.msg4"]}</Text>
        </View>
        <View className="pad-bottom-20">
          <Text>{messages["app.payments.vop.descModal.msg5"]}</Text>
        </View>
        <View className="btn-container">
          <Button
            size="large"
            onPress={ () => this.handleDescModal(false) }
          >
            {messages["app.common.closeText"]}
          </Button>
        </View>
      </>
    )
  }

  descModal = () => {
    const { i18n: { messages } } = this.props;
    return (
      <Modal
        onClose={ () => this.handleDescModal(false) }
        isActive={this.state.showDescModal}
        size="large"
        header={messages["app.payments.vop.descModal.header"]}
        content={
          <View className="info-container">
            {this.renderDescModalHeader()}
            {this.renderDescModalStatus()}
            {this.renderDescModalFooter()}
          </View>
        }
      />
    )
  }

  render() {
    const { i18n: { messages } } = this.props;
    return(
      <View
        className="info-icon cursor-pointer"
        tabIndex={0}
        aria-label={messages["app.payments.vop.descModal.header"] + " " + messages["app.dashboard.toolTip"]}
        onKeyDown={ (e) => this.handleDescModal(true, e) }
      >
        <Info2 
          height={35}
          width={35} 
          color={PALETTE.primaryText}
          onClick={ () => this.handleDescModal(true) }
        />
        {this.descModal()}
      </View>
    )
  }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    }
  }
})(HelptextDescription);